import { useQuery } from '@tanstack/react-query';

import HttpServiceSingleton from '../services/HttpService/HttpService';

interface FormsConfigResponse {
  data?: {
    features?: {
      enabled?: boolean;
      unAuthForm?: boolean;
      orchestration?: boolean;
    };
  };
  meta?: Record<string, unknown>;
}

const FIVE_MINUTES_MS = 5 * 60 * 1000;

const fetchFormsConfig = async (): Promise<boolean> => {
  const response = (await HttpServiceSingleton.get(
    '/ECMv6/api/ext/forms/config'
  )) as FormsConfigResponse | undefined;

  return response?.data?.features?.enabled ?? false;
};

/**
 * Checks whether the Form Builder / Form API is enabled via
 * GET /ECMv6/api/ext/forms/config → data.features.enabled
 *
 * Cached for 5 minutes to avoid redundant network calls.
 */
const useFormApiEnabled = () => {
  const { data: isFormApiEnabled = false, isLoading } = useQuery<boolean>({
    queryKey: ['FORM_API_ENABLED'],
    queryFn: fetchFormsConfig,
    staleTime: FIVE_MINUTES_MS,
    refetchOnWindowFocus: false,
  });

  return { isFormApiEnabled, isLoading };
};

export default useFormApiEnabled;
